<div class="container-fluid mt-3">
    <div class="row">
        <!-- 左: ユーザ一覧 -->
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header"><strong>{{ 'kobeac.user_list' | transloco }}</strong></div>
                <div class="card-body">
                    <p class="text-muted" style="font-size:12px">
                        {{ 'kobeac.member_desc' | transloco }}
                    </p>
                    <div class="row mb-2">
                        <div class="col-md-6"><span>{{ 'kobeac.n_hits' | transloco: {count: (users.totalCount | number)} }}</span></div>
                        <div class="col-md-6">
                            <button (click)="createUser()" class="btn btn-primary btn-block">{{ 'kobeac.create_new_user' | transloco }}</button>
                        </div>
                    </div>
                    <wj-flex-grid #grid [isReadOnly]="true" [itemsSource]="users" style="height:500px">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'kobeac.username' | transloco" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.email' | transloco" [binding]="'email'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.role' | transloco" [binding]="'roles'" [width]="200">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <span *ngFor="let role of cell.item.roles"> {{ role.name }} </span>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.customer' | transloco" [binding]="'customer'" [width]="200">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                {{ customerLabelOf(cell.item) }}
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'kobeac.status' | transloco" [binding]="'status'" [width]="120"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
                <div class="card-footer">
                    <div class="d-flex align-items-center flex-wrap">
                        <wj-menu [(value)]="users.pageSize" [header]="'kobeac.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                        <wj-collection-view-navigator class="ml-3" [cv]="users"></wj-collection-view-navigator>
                        <wj-collection-view-pager class="ml-3" [cv]="users"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右: 作成 / 編集 -->
        <div class="col-sm-6">
            <!-- 新規作成 -->
            <div class="card" *ngIf="isNew">
                <div class="card-header"><strong>{{ 'kobeac.create_user' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.username' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kobeac.username_placeholder' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.email_address' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [placeholder]="'kobeac.email_optional' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="password" class="form-control" [(ngModel)]="password" [placeholder]="'kobeac.password_min3' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password_confirm' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="password" class="form-control" [(ngModel)]="confirmPassword" [placeholder]="'kobeac.password_confirm' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.role' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                    <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.customer' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedCustomerRid">
                                    <option value="">{{ 'kobeac.not_set_fullwidth' | transloco }}</option>
                                    <option *ngFor="let c of customers" [value]="c['@rid']">{{ customerLabel(c) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.status' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status">
                                    <option value="ACTIVE">{{ 'kobeac.active' | transloco }}</option>
                                    <option value="SUSPENDED">{{ 'kobeac.inactive' | transloco }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!createValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" class="btn btn-block btn-danger" (click)="createUser()"><i class="fa fa-ban"></i> {{ 'kobeac.reset' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 既存編集 -->
            <div class="card" *ngIf="!isNew">
                <div class="card-header">
                    <strong *ngIf="mode == 'edit'">{{ 'kobeac.edit_user' | transloco }}</strong>
                    <strong *ngIf="mode != 'edit'">{{ 'kobeac.user' | transloco }}</strong>
                </div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.username' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [(ngModel)]="user.name" [placeholder]="'kobeac.username_placeholder' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.name }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.email_address' | transloco }}</label>
                            <div class="col-md-9">
                                <input *ngIf="mode == 'edit'" type="email" class="form-control" [(ngModel)]="user.email" [placeholder]="'kobeac.email_optional' | transloco">
                                <span *ngIf="mode != 'edit'">{{ user.email }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.role' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedRoleName">
                                    <option *ngFor="let role of assignableRoles" [value]="role.name">{{ role.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.customer' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="selectedCustomerRid">
                                    <option value="">{{ 'kobeac.not_set_fullwidth' | transloco }}</option>
                                    <option *ngFor="let c of customers" [value]="c['@rid']">{{ customerLabel(c) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.status' | transloco }}</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status">
                                    <option value="ACTIVE">{{ 'kobeac.active' | transloco }}</option>
                                    <option value="SUSPENDED">{{ 'kobeac.inactive' | transloco }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-12" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!editValid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.confirm' | transloco }}</button>
                        </div>
                        <div class="col-sm-12" *ngIf="mode == 'view'">
                            <button type="button" class="btn btn-block btn-primary" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.edit' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.save' | transloco }}</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> {{ 'common.back' | transloco }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- パスワード変更 (既存かつ編集時) -->
            <div class="card" *ngIf="!isNew && mode == 'edit'">
                <div class="card-header"><strong>{{ 'kobeac.password' | transloco }}</strong></div>
                <div class="card-body">
                    <div class="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password' | transloco }}</label>
                            <div class="col-md-9">
                                <input type="password" class="form-control" [(ngModel)]="newPassword" [placeholder]="'kobeac.password_min3' | transloco">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">{{ 'kobeac.password_confirm' | transloco }}</label>
                            <div class="col-md-9">
                                <input type="password" class="form-control" [(ngModel)]="confirmNewPassword" [placeholder]="'kobeac.password_confirm' | transloco">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="col-sm-12">
                        <button type="button" [disabled]="!passwordValid" class="btn btn-block btn-primary" (click)="changePassword()"><i class="fa fa-dot-circle-o"></i> {{ 'kobeac.change' | transloco }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
